import * as React from 'react';
import { useTheme } from 'styled-components';

const CLIP_ID = 'lock-icon-clip';

const LockIcon = () => {
	const theme = useTheme();

	return (
		<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath={`url(#${CLIP_ID})`}>
				<path
					d="M50 0C36.7392 0 24.0215 5.26784 14.6447 14.6447C5.26784 24.0215 0 36.7392 0 50C0 63.2608 5.26784 75.9785 14.6447 85.3553C24.0215 94.7322 36.7392 100 50 100C63.2608 100 75.9785 94.7322 85.3553 85.3553C94.7322 75.9785 100 63.2608 100 50C100 36.7392 94.7322 24.0215 85.3553 14.6447C75.9785 5.26784 63.2608 0 50 0Z"
					fill={theme.primaryBackground}
				/>
			</g>
			<path
				d="M49.5 18C40.54 18 33.25 25.29 33.25 34.25V41.2275C29.3877 45.2692 27 50.7317 27 56.75C27 69.1562 37.0938 79.25 49.5 79.25C61.9062 79.25 72 69.1562 72 56.75C72 50.7317 69.6123 45.2692 65.75 41.2275V34.25C65.75 25.29 58.46 18 49.5 18ZM49.5 23C55.7038 23 60.75 28.0475 60.75 34.25V37.2944C57.4358 35.3702 53.6003 34.25 49.5 34.25C45.3997 34.25 41.5642 35.3702 38.25 37.2944V34.25C38.25 28.0475 43.2962 23 49.5 23ZM49.5 39.25C59.15 39.25 67 47.1 67 56.75C67 66.4 59.15 74.25 49.5 74.25C39.85 74.25 32 66.4 32 56.75C32 47.1 39.85 39.25 49.5 39.25ZM49.5 49.25C46.7388 49.25 44.5 51.4888 44.5 54.25C44.5 56.0962 45.5112 57.6904 47 58.5566V61.75C47 63.1312 48.1187 64.25 49.5 64.25C50.8813 64.25 52 63.1312 52 61.75V58.5566C53.4888 57.6904 54.5 56.0962 54.5 54.25C54.5 51.4888 52.2612 49.25 49.5 49.25Z"
				fill="white"
			/>
			<defs>
				<clipPath id={CLIP_ID}>
					<rect width="100" height="100" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default LockIcon;
